export default {
  // QR Generator
  'qr.generator_title': 'PC QR Login',
  'qr.generator_subtitle': 'Scan the QR code on your mobile',
  'qr.login_success': 'Login Successful!',
  'qr.redirecting_dashboard': 'Redirecting to dashboard...',
  'qr.time_remaining': 'Time remaining',
  'qr.how_to_use': 'How to use',
  'qr.step_1': 'Log in on your mobile',
  'qr.step_2': 'Select QR scan menu',
  'qr.step_3': 'Scan this QR code',
  'qr.back_to_login': 'Back to login page',

  // QR Link
  'qr.checking': 'Checking QR code...',
  'qr.redirecting_remote': 'Redirecting to remote screen...',
  'qr.welcome': 'Welcome to Qpresen!',
  'qr.welcome_subtitle': 'Smarter presentations',
  'qr.login_required': 'Login required',
  'qr.login_required_desc': 'Please sign up or log in to connect with your PC via QR code.',
  'qr.feature_remote': 'Mobile Remote',
  'qr.feature_remote_desc': 'Control your presentation with your smartphone',
  'qr.feature_laser': 'Laser Pointer',
  'qr.feature_laser_desc': 'Use touch to control the laser pointer',
  'qr.feature_timer': 'Presentation Timer',
  'qr.feature_timer_desc': 'Check your presentation time in real-time',
  'qr.signup_action': 'Sign up',
  'qr.has_account_login': 'Already have an account? Log in',
  'qr.error_invalid': 'Invalid QR Code',
  'qr.error_invalid_desc': 'The QR code information is not valid.',
  'qr.error_expired': 'QR Code Expired',
  'qr.error_expired_desc': 'Please generate a new QR code on PC.',
  'qr.error_used': 'QR Code Already Used',
  'qr.error_used_desc': 'Please generate a new QR code on PC.',
  'qr.error_not_found': 'QR Code Not Found',
  'qr.error_not_found_desc': 'Please generate a new QR code on PC.',
  'qr.go_home': 'Go to Home',
  'qr.processing_error': 'An error occurred while processing the QR code.',

  // QR Scanner
  'qr.scan_title': 'QR Scan',
  'qr.scan_subtitle': "Scan the PC's QR code",
  'qr.login_required_scan': 'Login is required to use QR scan.',
  'qr.login_action': 'Log in',
  'qr.go_home_action': 'Go to Home',
  'qr.camera_permission_required': 'Camera permission required',
  'qr.camera_permission_desc': 'Please allow camera permission in browser settings to use QR scan.',
  'qr.permission_settings': 'Permission Settings',
  'qr.permission_step_1': 'Tap the <strong>lock icon</strong> or <strong>settings icon</strong> on the left side of the browser address bar',
  'qr.permission_step_2': 'Select <strong>Site Settings</strong> or <strong>Permissions</strong>',
  'qr.permission_step_3': 'Find <strong>Camera</strong> and change to <strong>Allow</strong>',
  'qr.permission_step_4': 'Then press the <strong>Retry</strong> button below',
  'qr.ios_safari_user': 'iOS Safari Users',
  'qr.ios_safari_hint': 'Settings App → Safari → Camera → Allow',
  'qr.retry_action': 'Retry',
  'qr.back_to_dashboard': 'Back to Dashboard',
  'qr.select_presentation': 'Select Presentation',
  'qr.select_presentation_desc': 'Choose a presentation to use as remote',
  'qr.auth_complete': 'QR authentication complete! Select a presentation.',
  'qr.loading_list': 'Loading list...',
  'qr.no_presentations': 'No presentations.',
  'qr.no_presentations_hint': 'Please upload a PDF on PC first.',
  'qr.align_qr': 'Align QR code within the frame',
  'qr.camera_preparing': 'Preparing camera...',
  'qr.scan_again': 'Scan again',
  'qr.scanning': 'Scanning...',
  'qr.tip': 'Tip',
  'qr.tip_desc': 'Point the camera at the QR code on the PC screen and it will be detected automatically.',
  'qr.camera_unavailable': 'Camera is unavailable. Please check if another app is using the camera.',
  'qr.invalid_qr': 'Invalid QR code.',
  'qr.login_first': 'Please log in first.',
  'qr.qr_not_found': 'QR code not found.',
  'qr.qr_already_used': 'This QR code has already been used.',
  'qr.qr_expired': 'This QR code has expired.',
  'qr.qr_not_found_timeout': 'QR code not found. Please try again.',
  'qr.qr_scan_error': 'An error occurred while processing the QR code.',
};
